function buildSiteUrl(path) {
  return path.startsWith('//')
    ? `${window.location.protocol}${path}`
    : `${window.location.origin}${path}`
}

export default buildSiteUrl
